module.exports = [["NORATE",0],["NORATES",0.5],["R1",1],["R1S",1.5],["R2",2],["R2S",2.5],["R3",3],["R3S",3.5],["R4",4],["R4S",4.5],["R5",5]]


//////////////////
// WEBPACK FOOTER
// ./src/projects/miami/front/configs/types/rating.json
// module id = IyD7
// module chunks = 9